import { toast } from 'react-toastify';
import { CODE_DOI_TUONG } from '../../../../phan-he-tiep-nhan-thanh-toan/constants/PhanHeTiepNhan';
import { CODE, REQUEST_FROM, REQUEST_TYPE, RESPONSE_MESSAGE } from '../../../../utils/Constant';
import { getWarehouseProcess } from '../../../../utils/ServicesUtils';
import { MA_LOAI_DOI_TUONG, WAREHOUSE_HANDLER_TYPE, WAREHOUSE_TYPE } from '../../../constants/Thuoc';
import { IKeVatTu, IVatTuItem, SearchVatTuParams } from '../../../models/VatTuModels';
import { getWarehouse } from '../../../services/ThuocService';
import { searchVatTu } from '../../../services/VatTuService';
import { getPriceByObjectType } from '../../modal-ke-thuoc/utils';

export const getListVatTu = async (
	query: SearchVatTuParams,
	setIsLoading?: (flag: boolean) => void
) => {
	try {
		setIsLoading?.(true);

		const response: IVatTuItem[] = await searchVatTu({
			...query,
			pageIndex: 1,
			pageSize: 100,
			isIventoryNoZero: true,
		});
		const result: IKeVatTu[] = response.map((vatTu: IVatTuItem) => ({
			...vatTu,
			id: vatTu.id.toString(),
			donVi: vatTu.unitofMeasureName,
			maVatTu: vatTu.code,
			tenVatTu: vatTu.name,
			tonKho: Number(vatTu.iventory) - Number(vatTu.peShipment),
			bidId: vatTu.bidId,
			serialNumber: vatTu.serialNumber,
			consignment: vatTu.consignment,
			giaBan: vatTu.salePrice,
			rateHealthInsurance: vatTu.rateHealthInsurance,
			svcFee: vatTu.servicePrice,
			svcFeeHospital: vatTu.hospitalPrice,
			svcFeeIns: vatTu.bhytPrice,
		}));

		return result;
	} catch (error) {
		console.error(error);
		toast.error(RESPONSE_MESSAGE.ERROR);
	} finally {
		setIsLoading?.(false);
	}
};

export const getWarehouseByVisitCode = async (
	visitCode: string,
	itemType?: 'drug' | 'item',
	generalInfo?: any
) => {
	try {
		let formCode = !generalInfo?.forDVKT ? REQUEST_FROM.KHAM_BENH : generalInfo?.isReturn ? REQUEST_FROM.HOAN_TRA : REQUEST_FROM.HAO_PHI;
		let medicalItemTypeCode = itemType === 'drug' ? REQUEST_TYPE.THUOC : REQUEST_TYPE.VAT_TU;
		const resWarehouseProcess = await getWarehouseProcess({
			formCode,
			medicalItemTypeCode,
			visitObjectTypeCode: visitCode
		});
		if (resWarehouseProcess?.data) {
			const params: Record<string, string | number | string[]> = {};

			if (generalInfo?.forDVKT) {
				params.assignedDepartment = [generalInfo?.fulfillDeptCode];
			}

			const { code, data } = await getWarehouse({
				...params,
				warehousePrescriptions: resWarehouseProcess?.data,
			});

			if (CODE.SUCCESS !== code) {
				toast.error('Đã có lỗi khi lấy danh sách kho, xin vui lòng thử lại');
				return [];
			}

			return data.content;
		} else {
			toast.error('Không tìm thấy cấu hình luồng kho');
			return [];
		}
		
	} catch (error) {
		console.error(error);
	}
};

export const getCellEditValue = ({
	rowUpdate,
	field,
	value,
	categories,
	patientInfo,
}: {
	rowUpdate: any;
	field: string;
	value: any;
	categories: any;
	patientInfo: any;
}) => {
	let fieldValue: Record<string, any> = {
		[field]: value,
	};
	const { visit } = patientInfo ?? {};
	const quantity = parseInt(rowUpdate?.soLuong ?? rowUpdate?.totalQuantity);
	const isInsuranceObjectType = CODE_DOI_TUONG.BAO_HIEM === visit?.visitObjectTypeCode;

	switch (field) {
		case 'objectType':
			const unitPrice = getPriceByObjectType(rowUpdate, value.code);
			fieldValue = {
				donGia: unitPrice,
				thanhTien: quantity * unitPrice,
				objectTypeCode: value.code,
				objectTypeName: value.name,
				objectTypeId: value.id,
			};
			break;
		case 'isOwnExpenses':
			if (isInsuranceObjectType) {
				const objectType: any = getObjectTypeOption(
					categories,
					value ? CODE_DOI_TUONG.VIEN_PHI : CODE_DOI_TUONG.BAO_HIEM
				);
				const unitPrice = getPriceByObjectType(rowUpdate, objectType?.code);
				fieldValue = {
					...fieldValue,
					objectTypeCode: objectType?.code,
					objectTypeName: objectType?.name,
					donGia: unitPrice,
					thanhTien: quantity * unitPrice,
				};
			}
			break;

		default:
			fieldValue = {
				[field]: value,
			};
			break;
	}

	return fieldValue;
};

const getObjectTypeOption = (categories: any, code: string) => {
	return (categories?.listDoiTuong ?? []).find((item: any) => item.code === code);
};
